import { Tooltip } from '@mui/material'
import React from 'react'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function ApproveIcon({tooltipTitle,onClick, fontSize}) {
  return (
   <>
   <Tooltip title={tooltipTitle}>
                  <CheckCircleIcon
                 
                style={{
                  color: "#00b13f",
                  fontSize: fontSize || "1.2rem",
                  cursor: "pointer",
                }}
                    variant="contained"
                 
                    onClick={onClick}
                  />
                </Tooltip>
   </>
  )
}
